import { render, staticRenderFns } from "./PersonPhotos.vue?vue&type=template&id=70ff9817&"
import script from "./PersonPhotos.vue?vue&type=script&lang=js&"
export * from "./PersonPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhotos.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports